<template>
  <div class="blog">
    <NavbarComp />
    <div id="headerSection">
      <div id="leftHeader">
        <h1>Blog Intelligo.Id</h1>
        <h2>
          Hallo teman-teman! Berikut showcase/portofolio dari beberapa
          teman-teman kita yang sudah bergabung bersama kami. <br />
          Yuk lihat !!!
        </h2>
      </div>
      <div id="rightHeader">
        <img src="../assets/picBlog.png" />
      </div>
    </div>
    <div class="container-2">
      <div class="row mt-5">
        <!-- card 1 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/cardblog1.png"
              alt="blog 1"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">Category</h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-blog">
                  <a href="#" class="btn btn-primary"> Baca selengkapnya </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 2 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/cardblog2.png"
              alt="blog 2"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">Category</h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-blog">
                  <a href="#" class="btn btn-primary"> Baca selengkapnya </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 3 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/cardblog3.png"
              alt="blog 3"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">Category</h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-blog">
                  <a href="#" class="btn btn-primary"> Baca selengkapnya </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 4 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/cardblog4.png"
              alt="blog 4"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">Category</h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-blog">
                  <a href="#" class="btn btn-primary"> Baca selengkapnya </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 5 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/cardblog5.png"
              alt="blog 5"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">Category</h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-blog">
                  <a href="#" class="btn btn-primary"> Baca selengkapnya </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 6 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/cardblog6.png"
              alt="blog 6"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">Category</h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-blog">
                  <a href="#" class="btn btn-primary"> Baca selengkapnya </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 7 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/cardblog7.png"
              alt="blog 7"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">Category</h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-blog">
                  <a href="#" class="btn btn-primary"> Baca selengkapnya </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 8 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/cardblog8.png"
              alt="blog 8"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">Category</h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-blog">
                  <a href="#" class="btn btn-primary"> Baca selengkapnya </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- card 9 -->
        <div class="col-md-4 mb-3">
          <div class="card rouded-none">
            <img
              class="card-img-top"
              src="../assets/cardblog9.png"
              alt="blog 9"
            />
            <div class="card-body">
              <h5 class="card-title" id="card-title-blog">
                Lorem ipsum dolor sit amet
              </h5>
              <h5 class="card-category">Category</h5>
              <p class="card-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                a auctor sed suspendisse ultrices. Non augue sed aliquam dolor
                tortor, volutpat tincidunt nibh est. Lobortis leo urna vitae id
                mauris massa. Netus magna elementum in mattis. In amet aliquam
                quis nulla nulla interdum. In ullamcorper phare...
              </p>
              <div class="text-center" id="button">
                <router-link to="/detail-blog">
                  <a href="#" class="btn btn-primary"> Baca selengkapnya </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-3 mt-4">
        <nav aria-label="Page navigation example">
          <ul class="pagination justify-content-center">
            <!-- <li class="page-item">
              <a class="page-link" href="#" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li> -->
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item"><a class="page-link" href="#">4</a></li>
            <li class="page-item"><a class="page-link" href="#">5</a></li>
            <li class="page-item"><a class="page-link" href="#">6</a></li>
            <li class="page-item"><a class="page-link" href="#">7</a></li>
            <li class="page-item"><a class="page-link" href="#">...</a></li>
            <li class="page-item"><a class="page-link" href="#">50</a></li>
            <li class="page-item">
              <a class="page-link" href="#" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <FooterComp />
  </div>
</template>

<script>
import NavbarComp from "../components/NavbarComp.vue";
import FooterComp from "../components/FooterComp.vue";
export default {
  name: "BlogComp",
  components: {
    NavbarComp,
    FooterComp,
  },
};
</script>

<style>
#headerSection {
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
  background-color: #f5f5f5;
}
#headerSection #leftHeader {
  width: 900px;
  margin-top: 138px;
  margin-bottom: 138px;
  margin-left: 70px;
  position: absolute;
  text-align: center;
}
#headerSection #leftHeader h1 {
  font-size: 32px;
  font-weight: 600;
  color: #ff5400;
}
#headerSection #leftHeader h2 {
  margin-top: 20px;
  font-size: 26px;
  font-weight: 400;
  color: #023047;
}
#headerSection #rightHeader img {
  margin-top: 30px;
  margin-left: 970px;
  width: 331px;
height: 400px;
}

.container-1 {
  padding: 100px 100px;
  margin-top: 5px;
  background: #f5f5f5;
}

.container-1 h1 {
  text-align: center;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  color: #ff5400;
}

.container-1 p {
  text-align: center;
  /* font-family: "Poppins"; */
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  color: #023047;
}

.container-2 {
  padding: 0px 100px;
}

#card-title-blog {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  color: #ff5400;
}

.card-category {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #023047;
}

.card-text {
  text-align: justify;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #0a0a0a;
}

#button {
  background: #d44600;
  border-radius: 20px;
  border: none;
}

#button a {
  background: #d44600;
  border: none;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
}

.page-item a {
  color: #848484;
}

@media only screen and (max-width: 500px) {
  #headerSection #leftHeader {
    width: 60%;
    margin-top: 80px;
    margin-bottom: 100px;
    margin-left: 0px;
  }
  #headerSection #leftHeader h1 {
    font-size: 16px;
  }
  #headerSection #leftHeader h2 {
    font-size: 10px;
    width: 100%;
    padding: 0 10px;
  }
  #headerSection #rightHeader {
    margin-top: 50px;
    margin-left: 60%;
  }
  #headerSection #rightHeader img {
    margin-left: 0;
    width: 124px;
    height: 150px;
  }
  .container-2 {
    padding: 0;
  }
  .card {
    margin-left: 20%;
    margin-bottom: 20px;
    width: 60%;
  }
  #card-title-blog {
    font-size: 14px;
  }
  .card-category {
    font-size: 12px;
  }
  .card-text {
    font-size: 10px;
  }
  #button a {
    font-size: 12px;
  }
  .container-3 {
    margin-left: 0%;
  }
  .page-item {
    width: 20px;
  }
  .page-item a {
    padding: 5px;
    font-size: 12px;
  }
}
</style>